import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';
import withMobileDialog from '@material-ui/core/withMobileDialog';

// Actions
import { updateQueryString } from '../../../../services/router/actions';

// Components
import asyncComponent from '../../../AsyncComponent';
import DatePickerButton from './components/DatePickerButton';

// Workspaces
import { makeSelectQueryStringValue } from '../../../../workspaces/react-router-selectors';

// Styles
import './styles.scss';

const AsyncDatePicker = asyncComponent(() => import('react-datepicker'));

interface Props {
    updateQueryString: Function;
    date?: string;
    fullScreen: boolean;
    numberOfDays?: number;
}

export class DatePaginationFormattedDate extends React.PureComponent<Props> {
    get date() {
        const { date } = this.props;
        if (!date) return null;
        return moment(date, 'YYYY-MM-DD').toDate();
    }

    handleChange = (date: string) => {
        this.props.updateQueryString({
            date: moment(date).format('YYYY-MM-DD'),
            page: undefined
        });
    };

    render() {
        const { fullScreen, numberOfDays } = this.props;
        return (
            <div className="date-pagination-formatted-date">
                <AsyncDatePicker
                    customInput={
                        <DatePickerButton numberOfDays={numberOfDays} />
                    }
                    selected={this.date}
                    onChange={this.handleChange}
                    withPortal={fullScreen}
                />
            </div>
        );
    }
}
const mapStateToProps = createStructuredSelector({
    date: makeSelectQueryStringValue('date')
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(withMobileDialog()(DatePaginationFormattedDate));
